<template>
  <div class="BackendList">
    <el-table
        height="600"
        class="table"
        :data="list">
      <el-table-column
          prop="id"
          label="ID"
          width="60">
      </el-table-column>
      <el-table-column
          label="Avatar"
          width="100">
        <template slot-scope="scope">
          <el-image
              style="width: 60px; height: 60px"
              :src="scope.row.user_avatar"
              fit="cover"></el-image>
        </template>
      </el-table-column>
      <el-table-column
          prop="user_name"
          label="Name"
          width="100">
      </el-table-column>
      <el-table-column
          prop="user_country"
          label="Country"
          width="100">
      </el-table-column>
      <el-table-column
          prop="user_province"
          label="Province"
          width="100">
      </el-table-column>
      <el-table-column
          prop="user_city"
          label="City"
          width="100">
      </el-table-column>
      <el-table-column
          prop="user_subtime"
          label="subtime"
          width="100">
      </el-table-column>
      <el-table-column
          prop="invite_code"
          label="invite_code"
          width="100">
      </el-table-column>
      <el-table-column
          prop="spread_id"
          label="spread_id"
          width="100">
      </el-table-column>
      <el-table-column
          label="Invite count"
          width="100">
        <template slot-scope="scope">
          {{ scope.row.spread_count }} / {{ scope.row.spread_limit }}
        </template>
      </el-table-column>
      <el-table-column
          width="80">
        <template slot-scope="scope">
          <el-button
              size="mini"
              type="primary"
              @click="onEdit(scope.row.id)">Edit
          </el-button>
          <!-- <el-button
              size="mini"
              type="primary"
              @click="onInvite(scope.row.id)">Enable Invite
          </el-button>
          <el-button
              size="mini"
              type="danger"
              :disabled="scope.row.user_self"
              @click="onDelete(scope.row.id)">Delete Invite
          </el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
        title="Edit User"
        custom-class="popup_user"
        :visible.sync="dialog_visible"
        width="30%">
      <BackendCreate v-if="dialog_visible" :uid="current_id" @update="onUpdate"></BackendCreate>
    </el-dialog>
  </div>
</template>

<script>
  import BackendCreate from "@/components/Management/BackendCreate/BackendCreate";
  import {deleteUserCode, createUserCode} from "@/utils/api";

  export default {
    components:{
      BackendCreate
    },
    props: ['list'],
    data: () => {
      return {
        dialog_visible:false,
        backend_list: [],
        current_id:'',
      }
    },
    methods: {
      onUpdate(){
        this.dialog_visible = false;
        this.$emit('update')
      },
      onEdit(id) {
        // this.$confirm(`Are you sure you want to Enable this user's Invite Code?`, 'Warning', {
        //   confirmButtonText: 'Yes',
        //   cancelButtonText: 'No',
        //   type: 'warning'
        // }).then(() => {
        //   createUserCode(id).then(() => {
            this.$emit('edit', id)
        //   })
        // }).catch(() => {});
      },
      onInvite(id) {
        this.$confirm(`Are you sure you want to Enable this user's Invite Code?`, 'Warning', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          type: 'warning'
        }).then(() => {
          createUserCode(id).then(() => {
            this.$emit('update')
          })
        }).catch(() => {});
      },
      onDelete(id) {
        this.$confirm(`Are you sure you want to Delete this user's Invite Code?`, 'Warning', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          type: 'warning'
        }).then(() => {
          deleteUserCode(id).then(() => {
            this.$emit('update')
          })
        }).catch(() => {});
      }
    },
    beforeMount() {

    }
  };
</script>

<style lang="scss" scoped>
  @import "_BackendList.scss";
</style>